export function LoadingScreen() {
  return (
    <div className="loading-screen">
      <div className="loader"></div>
      <p>Lädt...</p>
    </div>
  );
}
